<template>
  <section class="company-quote-plan-info">
    <div
      v-for="(excessItem, excessIndex) in ageLimit.items"
      :key="'limit-' + excessIndex">
      <div class="table">
        <span
          class="table-title">{{ excessItem.sub_title? excessItem.sub_title: ageLimit.title }}</span>
        <div
          v-for="(subItem, subIndex) in excessItem.sub_items"
          :key="'limit-' + excessIndex + subIndex"
          class="tr">
          <span>{{ subItem.item }}</span>
          <span>{{ subItem.premium }}</span>
        </div>
      </div>
    </div>
    <template v-if="!isSmeProduct">
      <div
        v-for="(excessItem, excessIndex) in excess.items"
        :key="'excess' + excessIndex">
        <div class="table">
          <span
            class="table-title">{{ excessItem.sub_title? excessItem.sub_title: excess.title }}</span>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'excess-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span>{{ subItem.premium }}</span>
          </div>
        </div>
      </div>

      <div
        v-for="(excessItem, excessIndex) in coverage.items"
        :key="'coverage' + excessIndex">
        <div class="table">
          <span
            class="table-title">{{ excessItem.sub_title? excessItem.sub_title: coverage.title }}</span>
          <div
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <span>{{ subItem.item }}</span>
            <span>{{ subItem.premium }}</span>
          </div>
        </div>
      </div>
      <div v-if="extraOption.length>0">
        <div class="table">
          <span
            class="table-title">Extra Benefits</span>
          <div
            v-for="(item, excessIndex) in extraOption"
            :key="'extra' + excessIndex"
            class="tr">
            <span>{{ item.title }}</span>
            <span>{{ item.premium }}</span>
          </div>
        </div>
      </div>
      <div v-if="specialList.length>0">
        <div class="table">
          <span
            class="table-title">{{specialData.title}}</span>
          <div
            v-for="(item, excessIndex) in specialList"
            :key="'specialList' + excessIndex"
            class="tr">
            <span>{{ item.val }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-if="excess.contents.length>0"
        class="table">
        <!--        <div-->
        <!--          class=" th">-->
        <!--          Excess-->
        <!--        </div>-->
        <span
          class="table-title">Excess</span>
        <template v-if="excess.contents.length>0">
          <section
            v-for="(excess_item,index) in excess.contents"
            :key="'excess_item'+index"
            class="table_tr_border0"
          >
            <div
              class="tr tr-gray__title">
              <span class="fw-600">{{excess_item.title}}</span>
            </div>
            <section
              v-for="(excess_content_item,index) in excess_item.items"
              :key="'excess_content_item'+index">
              <div
                class="tr">
                <span class="fw-600">{{excess_content_item.item}}</span>
                <span>{{excess_content_item.premium_str}}</span>
              </div>
            </section>
          </section>
        </template>
        <!--        <div class="tr">-->
        <!--          <span>Excess Remark</span>-->
        <!--          <span-->
        <!--            v-html="changeLineData(excess.remarks)"></span>-->
        <!--        </div>-->
      </div>
      <div
        v-if="coverage"
        class="table">
        <!--        <div-->
        <!--          class=" th">-->
        <!--          Coverage-->
        <!--        </div>-->
        <span
          class="table-title">Coverage</span>
        <template v-if="coverage.contents.length>0">
          <section
            v-for="(coverage_item,index) in coverage.contents"
            :key="'coverage_item'+index"
            class="table_tr_border0">
            <div
              class="tr tr-gray__title">
              <span class="fw-600">{{coverage_item.title}}</span>
            </div>
            <section
              v-for="(content_item,index) in coverage_item.items"
              :key="'content_item'+index">
              <div
                class="tr">
                <span class="fw-600">{{content_item.item}}</span>
                <span>{{content_item.premium_str}}</span>
              </div>
            </section>
          </section>
        </template>
        <!--        <div class="tr">-->
        <!--          <span>Coverage Remark</span>-->
        <!--          <span-->
        <!--            v-html="changeLineData(coverage.remarks)"></span>-->
        <!--        </div>-->
      </div>
    </template>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'

export default {
  name: 'CompanyQuotePlanInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    planInfo: {
      type: Object,
      default: () => ({
        excess: {},
        coverage: {},
        special_clause:{}
      })
    },
    isSmeProduct:{
      type:Boolean,
      default:false
    }
  },
  computed: {
    excess() {
      if(this.planInfo && this.planInfo.excess) {
        return this.planInfo.excess
      }
      return []
    },
    coverage() {
      if(this.planInfo && this.planInfo.coverage) {
        return this.planInfo.coverage
      }
      return []
    },
    extraOption() {
      let {extra_benefits_content={}} = this.planInfo||{}
      let arr = []
      if(this.planInfo && this.planInfo.extra_benefits_content) {
        let {items={}} = extra_benefits_content
        arr = Object.entries(items).map(item=>item[1])
      }
      return arr
    },
    ageLimit() {
      if(this.planInfo && this.planInfo.age_limit) {
        return this.planInfo.age_limit
      }
      return []
    },
    specialData(){
      let {special_clause} = this.planInfo||{}
      return  special_clause||{}
    },
    specialList(){
      let { items=[]} = this.specialData||{}
      return items||[]
    }
  }
}
</script>
<style lang="scss" scoped>
 .table-title {
        display: inline-block;
        padding-bottom: 2px;
        padding-left: 5px;
      font-size: 12px;
      font-weight: bold;
      color: #909399;
      line-height: 15px;
    }
</style>
